<template>
    <b-modal
      title="Apagar atributo"
      no-close-on-backdrop
      size="lg"
      ok-only
      centered
      hide-footer
      header-bg-variant="orange"
      header-text-variant="light"
      v-model="open"
      :busy="loading"
    >
    <b-row class="container">
      <b-col v-if="isDadAttribute" cols="12" class="my-4">
        <h5 class="text-center">Tem certeza que deseja excluir o atributo pai?</h5>
        <p class="text-center">Ao excluir o atributo pai, vai ser apagado os atributos filhos</p>
        <h4 class="text-center mt-4">{{ dataAttribute.attribute }}</h4>
      </b-col>

      <b-col v-else cols="12">
        <h5 class="text-center">Tem certeza que deseja excluir o atributo filho?</h5>
        <h4 class="text-center mt-4">{{ dataAttribute.values_attribute }}</h4>
      </b-col>

      <b-col cols="12" md="6" class="mt-4">
        <b-button @click="close()" variant="outline-danger" block>
         Cancelar
        </b-button>
      </b-col>
      <b-col cols="12" md="6" class="mt-4">
        <b-button v-if="!isDadAttribute" @click="deleteValueAttribute()" variant="danger" block>
          Apagar Atributo Filho 
        </b-button>
        <b-button v-else @click="deleteAttribute()" variant="danger" block>
          Apagar Atributo Pai
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import makeToast from '@/mixins/makeToast';

export default {
  name: 'DeleteAttributeModal',
  mixins: [makeToast],
  emits: ['getAttribute'],

  data() {
    return {
      loading: false,
      open: false,
      isDadAttribute: false,
      dataAttribute: [],
      shopkeeperId: null,
    };
  },

  methods: {
    ...mapActions('shopkeeper', [
      'validarCodInternoLojista'
    ]),

    toggleOpen({ dataAttribute = [], shopkeeperId = null, isDadAttribute = false  }) {
      this.open = !this.open;
      this.dataAttribute = dataAttribute;
      this.isDadAttribute = isDadAttribute;
      this.shopkeeperId = shopkeeperId;
    },
    deleteAttribute() {
      this.loading = true;

      const data = {
        id: this.dataAttribute.attribute_id,
        construp_user_id: this.shopkeeperId,
        name: this.dataAttribute.attribute
      };

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/deleteAttributeProduct', data)
        .then((response) => {
          if(!response.data.error) {
            this.makeToast(
              'Sucesso',
              `Atributo Apagado com sucesso`,
            );
            this.$emit('getAttribute');
            this.close();
          }
        })
        .catch((error) => {
          this.makeToast(
            'Erro',
            `Houve um erro ao salvar os dados`,
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    deleteValueAttribute() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/deleteValuesAttributeProduct', this.dataAttribute.valueAttributeId)
        .then((response) => {
          if(!response.data.error) {
            this.makeToast(
              'Sucesso',
              `Atributo apagado com sucesso`,
            );
            this.$emit('getAttribute');
            this.close();
          }
      })
      .catch((error) => {
        this.makeToast(
          'Erro',
          `Houve um erro ao salvar os dados`,
          'danger'
        );
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },
    close() {
      this.open = !this.open;
    },
  },
};
</script>